import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import Clarity from '@microsoft/clarity';

/**
 * Initialize Microsoft Clarity session recording.
 * Gated behind the 'sea-owaClarity' feature flag to enable recording for only a subset of users.
 * @param projectId The Clarity project ID for tracking this session
 */
export function initializeClarity(): void {
    if (!isGlobalFeatureEnabled('sea-owaClarity')) {
        return;
    }
    const projectId = 'bqsjhaycd1'; // Clarity project ID for OWA
    Clarity.init(projectId);
}
